<template>
    <div>
        <div
            v-for="(x, index) in items"
            :key="`row-${index}`"
            class="input-group"
            style="margin-bottom: 5px;"
        >
            <div class="input-group-prepend">
                <input type="text"
                       placeholder="Attribute"
                       class="input-group-text"
                       :id="`${name}[${items[index].key || index}]`"
                       v-model="items[index].key"
                />
            </div>
            <textarea
                type="text"
                class="form-control"
                :id="`${name}[attribute-${index}]`"
                v-model="items[index].value"
            />
            <div class="input-group-append">
                <a
                    href="#" class="btn btn-sm btn-secondary"
                    style="padding-top: 9px;"
                    @click.prevent="removeItem(index)">
                    Remove
                </a>
            </div>

            <input
                type="hidden"
                :name="`${name}[${items[index].key || index}]`"
                :value="items[index].value"
            />
        </div>

        <div class="float-right mb-2">
            <a
                href="#"
                @click.prevent="items.push(createEmptyItem())"
                class="btn btn-secondary"
            >Add Metadata</a>
        </div>
    </div>
</template>

<script>
export default {
  name: 'MetadataInput',

  props: {
    values: {
      type: Object,
      required: false,
      default: () => ({}),
    },
    name: {
      type: String,
      required: true,
    },
  },

  mounted() {
    if (Object.keys(this.values).length > 0) {
      this.items = [
        ...Object.entries(this.values)
          .map(([key, value]) => ({
            key,
            value,
          })),
      ];
    }

    if (this.items.length === 0) {
      this.items = [this.createEmptyItem()];
    }
  },

  data: () => ({
    items: [],
  }),

  computed: {
    total() {
      return this.items.length;
    },
  },

  methods: {
    removeItem(item) {
      this.items.splice(item, 1);

      if (this.total === 0) {
        this.items.push(this.createEmptyItem());
      }
    },

    createEmptyItem() {
      return {
        key: '',
        value: undefined,
      };
    },
  },

};
</script>

<style scoped>

</style>
